<template>
    <modal
      v-if="variableNode"
      ref="modal"
      id="agVariableNodeModal"
      styles="display:flex; flex-direction:column; padding:15px;"
      :draggable="true"
      :resizable="true"
      :adaptive="true"
      :shiftX=.5
      :shiftY=0
      width="1114px"
      class="modal-container"
      name="variableNodeModal"
      :class="{ 'agModal-loading': isLoading }"
      centered
      height="85%"
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      resize="resize"
      :fit-parent="true"
      :resize-directions="['r', 'l', 'tl', 'tr', 'bl', 'br']"
      :clickToClose="false"
      @keyup.enter.native="saveButton_click"
    >
      <div>
          <h4 v-if="variableNode._id" class="agModal-title">
            Edit Variable Node
          </h4>
          <h4 v-else class="agModal-title">New Variable Node</h4>
          <hr />
      </div>
      <div class="inner" style="height: 100%; overflow-y: auto; overflow-x:hidden; position:relative;">
      <b-input-group size="md" style="padding:14px;" prepend="Name">
        <b-input
          type="text"
          v-model="variableNode.name"
          autocomplete="false"
        ></b-input>
      </b-input-group>
      <b-input-group size="md" style="padding:14px;" prepend="Description">
        <b-input
          type="text"
          v-model="variableNode.description"
          autocomplete="false"
        ></b-input>
      </b-input-group>
      <hr />
      <div class="agInputGroup">
        <b-table
          :key="'vars-' + reloadVars"
          id="agVariableNodeModal-varsTable"
          :fields="varHeaders"
          :items="variableNode.vars"
          :thead-class="{ theadHidden: isLoadingVars }"
          borderless
          outlined
          small
        >
          <template #head(var)>
            Variable Name
          </template>
          <template #cell(var)="data">
            <b-input
              type="text"
              v-model="data.item.name"
              class="agVariableNodeModal-varTableVar"
              autocomplete="false"
              :disabled="disableUI"
              @keyup="var_keyup"
            >
            </b-input>
          </template>
          <template #cell(type)="data">
            <b-form-select
              v-model="data.item.type"
              class="agVariableNodeModal-varTableType"
              :options="varTypes"
              :disabled="disableUI"
              @change="type_change($event, data.index)"
            >
            </b-form-select>
          </template>
        </b-table>
        <b-spinner
          v-if="isLoadingVars"
          id="agVariableNodeModal-loadingVarsSpinner"
        ></b-spinner>
      </div>
      <div v-if="modalMessage">
        <hr />
        <label class="agModal-message" :class="modalMessageClass">{{
          modalMessage
        }}</label>
      </div>
      </div>
      <div>
        <b-button class="agModal-buttonLeft" @click="cancelButton_click"
          >Cancel</b-button
        >
        <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
        <b-button
          class="agModal-buttonRight"
          style="margin-left: 82%;"
          variant="danger"
          :disabled="disableUI || isLoading"
          @click="deleteButton_click"
          >Delete</b-button
        >
        <b-button
          class="agModal-buttonRight"
          style="float: right;"
          variant="primary"
          :disabled="isLoading"
          @click="saveButton_click"
          >Save</b-button
        >
      </div>

      <b-modal
        class="agModal"
        ref="deleteModal"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @keyup.enter.native="deleteButton_click"
      >
        <template slot="modal-header">
          <h4 class="agModal-title danger">Delete Variable Node</h4>
        </template>
        Are you sure you want to delete variable node
        <i>{{ name }}</i
        >?
        <template slot="modal-footer" slot-scope="{ cancel }">
          <b-button class="agModal-buttonLeft" @click="cancel"
            >Cancel</b-button
          >
          <b-button
            class="agModal-buttonRight"
            variant="danger"
            @click="confirmDeleteButton_click"
            >Delete</b-button
          >
        </template>
      </b-modal>
    </modal>
</template>

<script>
// components

// modules

export default {
  name: "ag-variableNode-modal",

  components: {},

  props: {
    node: Object,
    workflow: Object,
    disableUI: Boolean
  },

  data() {
    return {
      variableNode: null,
      isLoading: false,
      isLoadingVars: false,
      reloadVars: 0,
      modalMessage: "",
      modalMessageClass: "",
      varHeaders: ["var", "type"],
      varTypes: [
        { value: "-- None --", text: "-- None --" },
        { value: "bool", text: "Boolean" },
        { value: "date", text: "Date" },
        { value: "int", text: "Integer" },
        { value: "number", text: "Number" },
        { value: "object", text: "Object" },
        { value: "string", text: "String" }
      ]
    };
  },

  computed: {
    name() {
      if (this.variableNode.name) {
        return this.variableNode.name;
      }
      return this.variableNode.shortname;
    }
  },

  watch: {},

  created() {},

  mounted() {},

  methods: {
    // UI Events
    cancelButton_click() {
      this.$modal.hide("variableNodeModal");
    },

    async saveButton_click() {
      // check for unique var names
      for (var i = 0; i < this.variableNode.vars.length; i++) {
        var vari = this.variableNode.vars[i];
        var existing = this.variableNode.vars.find(a => a.name == vari.name);
        if (existing.length > 1) {
          this.modalMessage = "Variable names must be unique";
          this.modalMessageClass = "agModal-errorMessage";
          return;
        }
      }

      // remove last, empty row
      this.variableNode.vars.pop();

      var node = {
        object: this.variableNode,
        type: "variableNode"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/updateNode", {
        node: node
      });
      this.isLoading = false;
      if (result.data.success) {
        var updated = {
          type: "variableNode",
          object: result.data.node
        };
        this.hide();
        this.$emit("updatedNode", updated);
      } else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    deleteButton_click() {
      this.$refs.deleteModal.show();
    },

    async confirmDeleteButton_click() {
      this.$refs.deleteModal.hide();
      var node = {
        object: this.variableNode,
        type: "variableNode"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/deleteNode", {
        node: node
      });
      this.$emit("deletedNode", node);
      this.isLoading = false;
      this.hide();
    },

    var_keyup() {
      this.checkVarRows();
    },

    type_change(value, index) {
      var vari = this.variableNode.vars[index];
      if (vari.type == "-- None --") {
        vari.type = null;
      }
      this.checkVarRows();
    },

    // emitted Events

    // other

    show() {
      this.setVariableNode();
      setTimeout(() => {
        this.reset();
        this.$modal.show("variableNodeModal", { draggable: true });
        // this.$refs.modal.show();
      }, 250);
    },

    hide() {
      this.$modal.hide("variableNodeModal");
    },

    reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";

      // if no vars or the last mod has a saved value add an empty row
      if (!this.variableNode.vars) this.variableNode.vars = [];
      this.checkVarRows();
      this.reloadVars++;
    },

    setVariableNode() {
      if (this.node && this.node.type == "variableNode")
        this.variableNode = this.workflow.variableNodes.find(
          object => object._id == this.node.object._id
        );
      else this.variableNode = null;
    },

    // ensures there is one empty row at the end of the var table
    checkVarRows() {
      var varsToRemove = [];
      for (var i = 0; i < this.variableNode.vars.length; i++) {
        var vari = this.variableNode.vars[i];
        if (this.isVarEmpty(vari)) varsToRemove.push(vari);
      }
      this.variableNode.vars = this.variableNode.vars.filter(
        a => varsToRemove.indexOf(a) < 0
      );

      // add empty row as last var
      var newVar = {
        name: "",
        type: null
      };
      this.variableNode.vars.push(newVar);
    },

    isVarEmpty(vari) {
      if (!vari.name && !vari.type) return true;
      return false;
    }
  }
};
</script>

<style scoped lang="css">

#agVariableNodeModal-varsTable {
  text-align: center;
  width: 800px;
  margin: auto;
}

#agVariableNodeModal-loadingVarsSpinner {
  position: relative;
  left: 50%;
  margin-left: -20px;
}

.agVariableNodeModal-varTableVar {
  width: 600px;
  display: inline-block;
}

.agVariableNodeModal-varTableType {
  width: 200px;
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/nodes/VariableNodeModal.vue